import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBlogs, getBlogById } from '../../api/services/blogService';

export const fetchBlogsAction = createAsyncThunk(
  'blog/fetchBlogs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBlogs();
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to load blogs');
    }
  }
);

export const fetchBlogByIdAction = createAsyncThunk(
  'blog/fetchBlogById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getBlogById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to load blog');
    }
  }
);

const initialState = {
  list: [],
  byId: {},
  loading: false,
  error: null,
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    clearBlogError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchBlogsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBlogByIdAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogByIdAction.fulfilled, (state, action) => {
        state.loading = false;
        const blog = action.payload || {};
        if (blog?.id) state.byId[blog.id] = blog;
      })
      .addCase(fetchBlogByIdAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBlogError } = blogSlice.actions;
export default blogSlice.reducer;


